<template>
  <el-dialog :title="title" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" width="40%" append-to-body>
    <el-form :model="data" :rules="rules" ref="addForm" label-width="120px">
      <el-form-item label="公司:" prop="customerId">
        <customer-select ref="customerSelectRef" :form-param="data" :disabled="disabledFlag" :param-list="customerList" @change="customerChange"></customer-select>
      </el-form-item>
      <el-form-item label="联系人:" prop="contactId">
        <el-select :disabled="disabledFlag" v-model="data.contactId" placeholder="请选择联系人" clearable style="width:100%">
          <el-option v-for="dict in contactList" :key="dict.id" :label="dict.name" :value="dict.id"/>
        </el-select>
      </el-form-item>
      <el-form-item label="角色:" prop="role">
        <el-select v-model="data.role" placeholder="请选择" clearable style="width:100%" :disabled="businessFlag">
          <el-option v-for="dict in roleOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
        </el-select>
      </el-form-item>
      <el-form-item label="项目影响力:" prop="projectInfluence">
        <el-select v-model="data.projectInfluence" placeholder="请选择" clearable style="width:100%">
          <el-option v-for="dict in projectInfluenceOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
        </el-select>
      </el-form-item>
      <el-form-item label="倾向:" prop="inclination">
        <el-select v-model="data.inclination" placeholder="请选择" clearable style="width:100%">
          <el-option v-for="dict in inclinationOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
        </el-select>
      </el-form-item>
      <el-form-item label="是否直接沟通:" prop="directCommunication">
        <el-select v-model="data.directCommunication" placeholder="请选择" clearable style="width:100%">
          <el-option v-for="dict in directCommunicationOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
        </el-select>
      </el-form-item>
      <el-form-item label="沟通频率:" prop="communicationFrequency">
        <el-select v-model="data.communicationFrequency" placeholder="请选择" clearable style="width:100%">
          <el-option v-for="dict in communicationFrequencyOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
        </el-select>
      </el-form-item>
      <el-form-item label="公司诉求:" prop="companyDemand">
        <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" :maxlength="1000" show-word-limit v-model="data.companyDemand" placeholder="请输入" clearable/>
      </el-form-item>
      <el-form-item label="个人诉求:" prop="personalDemand">
        <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" :maxlength="1000" show-word-limit v-model="data.personalDemand" placeholder="请输入" clearable/>
      </el-form-item>
      <el-form-item label="备注:" prop="remark">
        <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" :maxlength="1000" show-word-limit v-model="data.remark" placeholder="请输入" clearable/>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>

</template>

<script>
import UserSelect from "@/views/crm/components/userSelect";
import CompanyInput from "@/views/crm/components/companyInput";
import {mapState} from 'vuex'
import {queryContactByCustomerId} from '@/api/crm/contact'
import {changeBusinessContact, queryBusinessContactByRelateId} from '@/api/crm/business'
import customerSelect from "@/views/crm/components/customerSelect";

export default {
  name: "addBusinessContactDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      title: '',
      customerList: [],
      roleOptions: [],
      projectInfluenceOptions: [],
      inclinationOptions: [],
      directCommunicationOptions: [],
      communicationFrequencyOptions: [],
      contactList: [],
      disabledFlag: false,
      businessFlag: false, // 是否在商机阶段中添加联系人
      rules: {
        customerId: [
          {required: true, type: 'number', message: '请选择公司', trigger: 'change'}
        ],
        contactId: [
          {required: true, message: '请选择联系人', trigger: 'change'}
        ],
        companyDemand: [
          {max: 1000, message: '长度过长', trigger: 'change'}
        ],
        personalDemand: [
          {max: 1000, message: '长度过长', trigger: 'change'}
        ],
        remark: [
          {max: 1000, message: '长度过长', trigger: 'change'}
        ]
      },
      data: {
        id: null,
        businessId: null,
        customerId: null,
        contactId: null,
        role: null,
        projectInfluence: null,
        inclination: null,
        directCommunication: null,
        communicationFrequency: null,
        companyDemand: null,
        personalDemand: null,
        remark: null
      }
    };
  },
  created() {
    this.getDicts("business_contact_role").then(response => {
      this.roleOptions = response.data;
    });
    this.getDicts("project_influence").then(response => {
      this.projectInfluenceOptions = response.data;
    });
    this.getDicts("inclination").then(response => {
      this.inclinationOptions = response.data;
    });
    this.getDicts("direct_communication").then(response => {
      this.directCommunicationOptions = response.data;
    });
    this.getDicts("communication_frequency").then(response => {
      this.communicationFrequencyOptions = response.data;
    });
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    UserSelect,
    CompanyInput,
    customerSelect
  },
  watch: {
    visible (val) {
      if (!val) {
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open (businessId, row, role) {
      this.data.businessId = businessId;
      this.visible = true;
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading'
      });
      this.disabledFlag = false
      if(role){
        this.data.role = role;
        this.businessFlag = true
      }else {
        this.businessFlag = false
      }
      if (row) {
        this.customerList = [{id: row.customerId, customerName: row.customerName}]
        this.disabledFlag = true
        this.title = '编辑商机联系人'
        queryBusinessContactByRelateId({id:row.id}).then(response => {
          this.data.id = response.data.id;
          this.data.businessId = response.data.businessId;
          this.data.customerId = row.customerId;
          this.customerChange(this.data.customerId)
          this.data.contactId = response.data.contactId;
          this.data.role = response.data.role.toString();
          this.data.projectInfluence = response.data.projectInfluence.toString();
          this.data.inclination = response.data.inclination.toString();
          this.data.directCommunication = response.data.directCommunication.toString();
          this.data.communicationFrequency = response.data.communicationFrequency.toString();
          this.data.companyDemand = response.data.companyDemand;
          this.data.personalDemand = response.data.personalDemand;
          this.data.remark = response.data.remark;
          loading.close()
          this.visible = true
        }).catch(error => {
          loading.close()
        })
      } else {
        this.title = '新增商机联系人'
        loading.close()
      }
    },
    customerChange(customerId) {
      this.contactList = []
      this.data.contactId = null
      if (customerId) {
        queryContactByCustomerId({customerId: customerId}).then(response => {
          this.contactList = response.data;
        });
      }
    },
    confirm () {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          changeBusinessContact(this.data).then(response => {
            this.$emit('success')
            this.visible = false
            loading.close();
            this.msgSuccess("操作成功");
            this.$emit('success')
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
